import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'CNinsurance',
    data () {
        return {
            admin:{},
            cninsurance_listings: {},
            cninsurance: {},
            cninsurance_forms:{},
            cninsurance_form:{},
            cninsurance_claim:{},
            cninsurance_complaint:{},
            cninsurance_discount:{},
            panelFlag: false,
            viewFlag: false,
            component_view:{},
            component_attr_view:{},
            set_component_view:{},
            toggle_indexes:{},
            load_processes: true,
            data_processing_message:"",
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        closeModal(modal){
            $(modal).modal("hide");
        },

        setProcessLoading(){
            this.disable_btn = true;
            this.process_loading = true;
        },
        stopProcessLoading(){
            this.disable_btn = false;
            this.process_loading = false;
        },

        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "view"){
                this.viewFlag = true;
                this.cninsurance = attr2;
            }
        },

        setComponentView(view){
            this.component_view = {};
            this.component_view[view] = true;
        },

        setComponentAttributeView(view){
            this.component_attr_view = {};
            this.component_attr_view[view] = true;
        },

        storeActiveToggleIndex(view,attr){
            this.toggle_indexes = {};
            this.toggle_indexes[view] = attr;
        },

        togglePanView(view){
            let view_set = document.getElementById(view).style.display;
            if(view_set == "none"){
                document.getElementById(view).style.display = "block";
            }else if(view_set == "block"){
                document.getElementById(view).style.display = "none";
            }
        },
        
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        setContentView(view,attr1,attr2){
            if(view == 'form_content'){
                this.cninsurance_form = attr1;
                $('#form_content').modal();
            }else if(view == 'claim_content'){
                this.cninsurance_claim = attr1;
                $('#claim_content').modal();
            }else if(view == 'complaint_content'){
                this.cninsurance_complaint = attr1;
                $('#complaint_content').modal();
            }
        },

        //
        setGetComponentView(view,attr){
            this.component_view = {};
            this.component_view[view] = true;
            //
            if(view == 'viewForm'){
                this.cninsurance_form = attr;
            }
            if(view == 'viewSubmittedForms'){
                this.getCNinsuranceForms();
            }else if(view == 'viewFiledClaims'){
                this.getCNinsuranceFiledClaims();
            }else if(view == 'viewFiledComplaints'){
                this.getCNinsuranceFiledComplaints();
            }
        },
        
        
        //
        getCNinsuranceFiledComplaints(){
            service.getCNinsurance(this).then(data => {
                if(data.body.status == 200) {
                    this.cninsurance_listings = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //
        getCNinsuranceFiledClaims(){
            service.getCNinsurance(this).then(data => {
                if(data.body.status == 200) {
                    this.cninsurance_listings = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //
        getCNinsuranceForms(){
            this.load_processes = true;
            service.getCNinsuranceForms(this,this.cninsurance.cninsurance_id).then(data => {
                if(data.body.status == 200) {
                    this.cninsurance_forms = data.body.data;
                    this.load_processes = false;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
                this.load_processes = false;
            })
        },

        //get all listings
        getCNinsuranceListings() {
            this.setProcessLoading();
            service.getCNinsurance(this).then(data => {
                if(data.body.status == 200) {
                    this.cninsurance_listings = data.body.data;
                    this.setPanel('view',this.cninsurance_listings[0]);
                    this.stopProcessLoading();
                    this.load_processes = false;
                }
            }).catch((err) => {
                if(err) {
                    // console.log(err)
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        editCNinsuranceDetails(){
            this.setProcessLoading();
            if((this.cninsurance.cninsurance_name != '') && (this.cninsurance.cninsurance_name != undefined)){
                service.updateCNinsuranceDetails(this,this.cninsurance.cninsurance_id,this.cninsurance).then(data => {
                    this.getCNinsuranceListings();
                    this.setComponentView('');
                 }).catch((err) => {
                     if(err) {}
                     this.getCNinsuranceListings();
                    this.setComponentAttributeView('');
                 })
            }
        },

        setCNinsuraceFormPrice(cninsurance,fv){
            this.setProcessLoading();
            let payload = {
                cninsurance_price_id: fv.cninsurance_form_variable_price_id,
                cninsurance_new_price: fv.cninsurance_form_price,
            }
            if(payload.cninsurance_new_price > 0){
                service.updateCNinsuraceFormPrice(this,cninsurance.cninsurance_id,payload).then(data => {
                    if(data.body.status == 200) {
                        this.setComponentAttributeView('');
                    }
                    this.getCNinsuranceListings();
                 }).catch((err) => {
                     if(err) {
                         //toastr.error('Sorry, could not process information', 'Warning!');
                     }
                 })
            }
        },

        addNewDiscount() {
            this.data_processing_message = ""; //reset
            // //some settings
            var payload = {
                cninsurance_discount_cninsurance: this.cninsurance.cninsurance_id,
                cninsurance_discount_code: this.cninsurance_discount.discount_code || "",
                cninsurance_discount_type: this.cninsurance_discount.discount_type || "C",
                cninsurance_discount_value: this.cninsurance_discount.discount_value || 0,
                cninsurance_discount_start_date: this.cninsurance_discount.discount_start_date || "",
                cninsurance_discount_expiry_date: this.cninsurance_discount.discount_expiry_date || "",
            }
            if((payload.cninsurance_discount_cninsurance > 0) 
                && (payload.cninsurance_discount_value > 0) 
                && (payload.cninsurance_discount_code != '')
                && (payload.cninsurance_discount_start_date != '')
                && (payload.cninsurance_discount_expiry_date != '')
            ){
                this.setProcessLoading();
                service.addCNinsuranceDiscount(this,payload).then(data => {
                    if(data.body.status == 201) {
                        this.setComponentView('');
                    }
                    this.getCNinsuranceListings();
                }).catch((err) => {
                    if(err) {
                        this.stopProcessLoading();
                        //toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else{
                this.data_processing_message = 'Please check details entered';
            }
        },

        updateDiscount(discount){
            this.setProcessLoading();
            if((discount.cninsurance_discount_code != '') && (discount.cninsurance_discount_code != undefined)){
                service.updateCNinsuranceDiscount(this,discount.cninsurance_discount_id,discount).then(data => {
                    this.getCNinsuranceListings();
                    this.setComponentAttributeView('');
                 }).catch((err) => {
                     if(err) {}
                     this.getCNinsuranceListings();
                    this.setComponentAttributeView('');
                 })
            }
        }
        
        
     
    },
    created: function(){
        this.preset();
        this.getCNinsuranceListings();
    }
}


// WEBPACK FOOTER //
// ./src/components/CNinsurance/script.js